import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AlertController, IonInput } from '@ionic/angular';
import { Store } from '@ngrx/store';

import { TerminosPage } from '../../../../private/terminos/terminos.page';
import { SharedAnalyticsService } from '../../../../shared/analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsPageViews } from '../../../../shared/enums/analytics.enum';
import { EventInteraction, GTMInteractions, SECTIONS } from '../../../../shared/models/Constants';
import { AnalyticsService } from '../../../../shared/services/analytics.service';
import { AuthService } from '../../../../shared/services/auth-service';
import { SharedServiceService } from '../../../../shared/services/shared-service.service';
import { preRegisterUser } from './../../../../store/actions/authentication.actions';
import { AppState } from './../../../../store/app-reducers';

@Component({
  selector: 'app-inputs-registro',
  templateUrl: './inputs-registro.component.html',
  styleUrls: ['./inputs-registro.component.scss'],
})

export class InputsRegistroComponent implements OnInit, OnDestroy {

  @Input() validClientForm: UntypedFormGroup;
  @Input() spinner = false;

  @Output() validated = new EventEmitter<boolean>()

  private openAlertC: HTMLIonAlertElement = null

  constructor(
    private shareService: SharedServiceService
    , private analytService: AnalyticsService
    , private sharedAnalyticsS: SharedAnalyticsService
    , public alert: AlertController
    , private authS: AuthService
    , private store: Store<AppState>
  ) { }

  ngOnInit() {
  }

  async ngOnDestroy() {
    if (this.openAlertC !== null) {
      await this.openAlertC.dismiss()
    }
    await this.shareService.dismissModalLegales()
  }

  ionViewDidEnter() {
    this.sharedAnalyticsS.trackPageView(EAnalyticsPageViews.registerInitialDataView, SECTIONS.PERFIL);
  }

  public gotoNextField = (nextElement: IonInput) => nextElement.setFocus();

  public onSubmitTemplate = () => {
    if (this.validClientForm.invalid) { return; }
    this.spinner = true
    this.analytService.sendEventAnalytics(GTMInteractions.initialDataRegisterAcceptEvent, EventInteraction)

    const objectParams = {
      ID_Bodega: this.validClientForm.get('bodega').value
      , NUD: this.validClientForm.get('nud').value
      , Telefono: this.validClientForm.get('phone').value
    }
    this.store.dispatch(preRegisterUser(objectParams));
  }

  public validateCheck = () =>
    this.analytService.sendEventAnalytics(GTMInteractions.acceptTermsEvent, EventInteraction);

  public openTerminos = async (tipo: string) => {
    await this.shareService.loadingBottle()
    // TODO JAIR: VALIDAR INTERACCION
    this.analytService.fbAnalytics('interacciones', { data_categoria: 'usuario_no_registrado', data_accion: '/registro/registro', data_etiqueta: tipo })

    const data = await this.shareService.modalLegales(TerminosPage, tipo)
    this.validClientForm.get(tipo).setValue(data);

    // TODO JAIR: VALIDAR INTERACCION
    this.analytService.fbAnalytics('interacciones', { data_categoria: tipo, data_accion: '/registro/registro', data_etiqueta: data ? 'aceptar' : 'atras' })
  }


}
